<template>
    <div>
        <Row>
            <Col span="24">
                <Row style="width: 100%;height: 51px;">
                    <Col span="24">
                        <Row :gutter="10">
                            <!-- 账号 -->
                            <Col span="6">
                               <Select v-model="account" @on-change="changeAccount(account)" :transfer="true" style="width:300px;" :placeholder="$t('TrustAdvisor.account')">
                                    <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                                </Select>
                            </Col>
                        </Row>
                    </Col>
                </Row>                    
            </Col>
        </Row> 
        
        <Row :gutter="10" style="margin-bottom: 12px;">
            <Col span="12">
                <Card :padding="8" class="demo-spin-container">
                    <Row>
                        <Col class="title">{{$t('TrustAdvisor.highAvailability')}}</Col>
                    </Row>
                    <Row class="main" style="padding-left: 10px;">
                        <Col span="24"><span>{{suggestNumberFaultToleranceStatistics}}</span> {{$t('TrustAdvisor.suggestion')}}</Col>
                        <!-- 进度条 -->
                        <Row>
                            <Col span="24">
                                <div id="highAvailability" style="width:100%;height: 50px;"></div>
                            </Col>
                        </Row>
                        
                        <Row style="margin-bottom: 30px;">
                            <Col span="8"><span>{{highNumberFaultToleranceStatistics}}</span> {{$t('TrustAdvisor.greatestInfluence')}}</Col>
                            <Col span="8"><span>{{mediumNumberFaultToleranceStatistics}}</span> {{$t('TrustAdvisor.mediumInfluence')}}</Col>
                            <Col span="8"><span>{{lowNumberFaultToleranceStatistics}}</span> {{$t('TrustAdvisor.lowestInfluence')}}</Col>
                        </Row>
                        <Row style="margin-bottom: 20px;">
                            <Col span="16"><span>{{affectedResourcesNumberFaultToleranceStatistics}}</span> {{$t('TrustAdvisor.influencedResources')}}</Col>
                            <Col span="2" style="float: right;margin-right: 20px;">
                                <router-link :to='{ path: "/monitor/trustAdvisorDetail",query: {name:$t("TrustAdvisor.highAvailability"),accountId:this.account,type:2 }}'>
                                    <Button>{{$t('TrustAdvisor.detail')}}</Button>
                                </router-link>
                            </Col>
                        </Row>
                    </Row>
                    <Spin fix v-if="spinShow" size="large"></Spin>
                </Card>
            </Col>
            <Col span="12">
                <Card :padding="8" class="demo-spin-container">
                    <Row>
                        <Col class="title">{{$t('TrustAdvisor.security')}}</Col>
                    </Row>
                    <Row class="main" style="padding-left: 10px;">
                        <Col span="24"><span>{{suggestNumberSecurityStatistics}}</span> {{$t('TrustAdvisor.suggestion')}}</Col>
                         <!-- 进度条 -->
                        <Row>
                            <Col span="24">
                                <div id="safety" style="width:100%;height: 50px;"></div>
                            </Col>
                        </Row>
                        <Row style="margin-bottom: 30px;">
                            <Col span="8"><span>{{highNumberSecurityStatistics}}</span> {{$t('TrustAdvisor.greatestInfluence')}}</Col>
                            <Col span="8"><span>{{mediumNumberSecurityStatistics}}</span> {{$t('TrustAdvisor.mediumInfluence')}}</Col>
                            <Col span="8"><span>{{lowNumberSecurityStatistics}}</span> {{$t('TrustAdvisor.lowestInfluence')}}</Col>
                        </Row>
                        <Row style="margin-bottom: 20px;">
                            <Col span="16"><span>{{affectedResourcesNumberSecurityStatistics}}</span> {{$t('TrustAdvisor.influencedResources')}}</Col>
                            <Col span="2" style="float: right;margin-right: 20px;">
                                <router-link :to='{ path: "/monitor/trustAdvisorDetail",query: {name:$t("TrustAdvisor.security"),accountId:this.account,type:1 }}'>
                                    <Button>{{$t('TrustAdvisor.detail')}}</Button>
                                </router-link>
                            </Col>
                        </Row>
                    </Row>
                    <Spin fix v-if="spinShow" size="large"></Spin>
                </Card>
            </Col>
        </Row> 
        <Row :gutter="10" style="margin-bottom: 10px;">
            <Col span="12">
                <Card :padding="8" class="demo-spin-container">
                    <Row>
                        <Col class="title">{{$t('TrustAdvisor.performance')}}</Col>
                    </Row>
                    <Row class="main" style="padding-left: 10px;">
                        <Col span="24"><span>{{suggestNumberPerformanceStatistics}}</span> {{$t('TrustAdvisor.suggestion')}}</Col>
                         <!-- 进度条 -->
                        <Row>
                            <Col span="24">
                                <div id="performance" style="width:100%;height: 50px;"></div>
                            </Col>
                        </Row>
                        <Row style="margin-bottom: 30px;">
                            <Col span="8"><span>{{highNumberPerformanceStatistics}}</span> {{$t('TrustAdvisor.greatestInfluence')}}</Col>
                            <Col span="8"><span>{{mediumNumberPerformanceStatistics}}</span> {{$t('TrustAdvisor.mediumInfluence')}}</Col>
                            <Col span="8"><span>{{lowNumberPerformanceStatistics}}</span> {{$t('TrustAdvisor.lowestInfluence')}}</Col>
                        </Row>
                        <Row style="margin-bottom: 20px;">
                            <Col span="16"><span>{{affectedResourcesNumberPerformanceStatistics}}</span> {{$t('TrustAdvisor.influencedResources')}}</Col>
                            <Col span="2" style="float: right;margin-right: 20px;">
                                <router-link :to='{ path: "/monitor/trustAdvisorDetail",query: {name:$t("TrustAdvisor.performance"),accountId:this.account,type:3 }}'>
                                    <Button>{{$t('TrustAdvisor.detail')}}</Button>
                                </router-link>
                            </Col>
                        </Row>
                    </Row>
                    <Spin fix v-if="spinShow" size="large"></Spin>
                </Card>
            </Col>
            <Col span="12">
                <Card :padding="8" class="demo-spin-container">
                    <Row>
                        <Col class="title">{{$t('TrustAdvisor.cost')}}</Col>
                    </Row>
                    <Row class="main" style="padding-left: 10px;">
                        <Col span="24"><span>{{suggestNumberCostOptimizingStatistics}}</span> {{$t('TrustAdvisor.suggestion')}}</Col>
                         <!-- 进度条 -->
                        <Row>
                            <Col span="24">
                                <div id="cost" style="width:100%;height: 50px;"></div>
                            </Col>
                        </Row>
                        <Row style="margin-bottom: 30px;">
                            <Col span="8"><span>{{highNumberCostOptimizingStatistics}}</span> {{$t('TrustAdvisor.greatestInfluence')}}</Col>
                            <Col span="8"><span>{{mediumNumberCostOptimizingStatistics}}</span> {{$t('TrustAdvisor.mediumInfluence')}}</Col>
                            <Col span="8"><span>{{lowNumberCostOptimizingStatistics}}</span> {{$t('TrustAdvisor.lowestInfluence')}}</Col>
                        </Row>
                        <Row style="margin-bottom: 20px;">
                            <Col span="16"><span>{{affectedResourcesNumberCostOptimizingStatistics}}</span> {{$t('TrustAdvisor.influencedResources')}}</Col>
                            <Col span="2" style="float: right;margin-right: 20px;">
                                <router-link :to='{ path: "/monitor/trustAdvisorDetail",query: {name:$t("TrustAdvisor.cost"),accountId:this.account,type:0 }}'>
                                    <Button>{{$t('TrustAdvisor.detail')}}</Button>
                                </router-link>
                            </Col>
                        </Row>
                    </Row>
                    <Spin fix v-if="spinShow" size="large"></Spin>
                </Card>
            </Col>
        </Row>          
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    export default {
        name: 'TrustAdvisorList',
        data(){
            return {
                chartHighAvailability:'',
                chartSafety:'',
                chartPerformance:'',
                chartCost:'',
                spinShow:true, //加载中
                account:'',
                accountList:[],
                suggestNumberFaultToleranceStatistics:'',
                highNumberFaultToleranceStatistics:'',
                mediumNumberFaultToleranceStatistics:'',
                lowNumberFaultToleranceStatistics:'',
                affectedResourcesNumberFaultToleranceStatistics:'',//高可用性
                suggestNumberSecurityStatistics:'',
                highNumberSecurityStatistics:'',
                mediumNumberSecurityStatistics:'',
                lowNumberSecurityStatistics:'',
                affectedResourcesNumberSecurityStatistics:'',//安全性
                suggestNumberPerformanceStatistics:'',
                highNumberPerformanceStatistics:'',
                mediumNumberPerformanceStatistics:'',
                lowNumberPerformanceStatistics:'',
                affectedResourcesNumberPerformanceStatistics:'',//性能
                suggestNumberCostOptimizingStatistics:'',
                highNumberCostOptimizingStatistics:'',
                mediumNumberCostOptimizingStatistics:'',
                lowNumberCostOptimizingStatistics:'',
                affectedResourcesNumberCostOptimizingStatistics:'', //成本
                to:'/monitor/trustAdvisorDetail'
            }
        },
        mounted(){
            this.getAccount();
            // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartHighAvailability.resize();
                self.chartSafety.resize();
                self.chartPerformance.resize();
                self.chartCost.resize();
            });
        },
        methods:{
            /******************所有图表********************************/
            init:function(){
                this.highAvailabilityLine();
                this.performanceLine();
                this.safetyLine();
                this.costLine();
            },
            /*************图表*****************************/
            // 高可用性
            highAvailabilityLine:function(){
                this.chartHighAvailability=this.$echarts.init(document.getElementById("highAvailability"));
                this.chartHighAvailability.setOption({
                    // 设置图表的位置
                    grid: {
                        x:0, // 左间距
                        y: 0, // 上间距
                        x2: 10, // 右间距
                        y2: 0, // 下间距
                        containLabel: true 
                    },
                    color: ['#cc0000', '#e07700', '#009933'],   
                    // X轴
                    xAxis: {
                        type: 'value', 
                        axisTick: {
                            show: false 
                        },
                        axisLine: { 
                            show: false 
                        },
                        splitLine: {
                            show: false 
                        },
                        axisLabel: {
                            show: false 
                        }
                    },
                    yAxis: [
                        {
                            type: 'category', 
                            axisTick: {
                              show: false 
                            },
                            axisLine: { 
                                show: false, 
                                lineStyle: { 
                                    color: '#cdd3ee'
                                }
                            },
                            splitLine: {
                                show: false
                            },
                            axisLabel: {
                                show: false, 
                                fontSize: 2, 
                                color: '#cdd3ee', 
                                formatter: '{value}'
                            },
                            data: [this.$t('TrustAdvisor.influence')] 
                        }
                    ],
                    // 系列列表
                    series: [
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [10, 0, 0, 10]
                            },
                            data: [this.highNumberFaultToleranceStatistics]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            data: [this.mediumNumberFaultToleranceStatistics]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [0, 10, 10, 0] 
                            },
                            data: [this.lowNumberFaultToleranceStatistics]
                        }
                    ]
                })
            },
            // 安全性
            safetyLine:function(){
                this.chartSafety=this.$echarts.init(document.getElementById("safety"));
                this.chartSafety.setOption({
                    grid: {
                        x:0, // 左间距
                        y: 0, // 上间距
                        x2: 10, // 右间距
                        y2: 0, // 下间距
                        containLabel: true 
                    },
                    color: ['#cc0000', '#e07700', '#009933'],   
                    // X轴
                    xAxis: {
                        type: 'value', 
                        axisTick: {
                            show: false 
                        },
                        axisLine: { 
                            show: false 
                        },
                        splitLine: {
                            show: false 
                        },
                        axisLabel: {
                            show: false 
                        }
                    },
                    yAxis: [
                        {
                            type: 'category', 
                            axisTick: {
                              show: false 
                            },
                            axisLine: { 
                                show: false, 
                                lineStyle: { 
                                    color: '#cdd3ee'
                                }
                            },
                            splitLine: {
                                show: false
                            },
                            axisLabel: {
                                show: false, 
                                fontSize: 2, 
                                color: '#cdd3ee', 
                                formatter: '{value}'
                            },
                            data: [this.$t('TrustAdvisor.influence')] 
                        }
                    ],
                    // 系列列表
                    series: [
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [10, 0, 0, 10]
                            },
                            data: [this.highNumberSecurityStatistics]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            data: [this.mediumNumberSecurityStatistics]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [0, 10, 10, 0] 
                            },
                            data: [this.lowNumberSecurityStatistics]
                        }
                    ]
                })
            },
            // 性能
            performanceLine:function(){
                this.chartPerformance=this.$echarts.init(document.getElementById("performance"));
                this.chartPerformance.setOption({
                    grid: {
                        x:0, // 左间距
                        y: 0, // 上间距
                        x2: 10, // 右间距
                        y2: 0, // 下间距
                        containLabel: true 
                    },
                    color: ['#cc0000', '#e07700', '#009933'],   
                    // X轴
                    xAxis: {
                        type: 'value', 
                        axisTick: {
                            show: false 
                        },
                        axisLine: { 
                            show: false 
                        },
                        splitLine: {
                            show: false 
                        },
                        axisLabel: {
                            show: false 
                        }
                    },
                    yAxis: [
                        {
                            type: 'category', 
                            axisTick: {
                              show: false 
                            },
                            axisLine: { 
                                show: false, 
                                lineStyle: { 
                                    color: '#cdd3ee'
                                }
                            },
                            splitLine: {
                                show: false
                            },
                            axisLabel: {
                                show: false, 
                                fontSize: 2, 
                                color: '#cdd3ee', 
                                formatter: '{value}'
                            },
                            data: [this.$t('TrustAdvisor.influence')] 
                        }
                    ],
                    // 系列列表
                    series: [
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [10, 0, 0, 10]
                            },
                            data: [this.highNumberPerformanceStatistics]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            data: [this.mediumNumberPerformanceStatistics]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [0, 10, 10, 0] 
                            },
                            data: [this.lowNumberPerformanceStatistics]
                        }
                    ]
                })
            },
            // 成本
            costLine:function(){
                this.chartCost=this.$echarts.init(document.getElementById("cost"));
                this.chartCost.setOption({
                    grid: {
                        x:0, // 左间距
                        y: 0, // 上间距
                        x2: 10, // 右间距
                        y2: 0, // 下间距
                        containLabel: true 
                    },
                    color: ['#cc0000', '#e07700', '#009933'],   
                    // X轴
                    xAxis: {
                        type: 'value', 
                        axisTick: {
                            show: false 
                        },
                        axisLine: { 
                            show: false 
                        },
                        splitLine: {
                            show: false 
                        },
                        axisLabel: {
                            show: false 
                        }
                    },
                    yAxis: [
                        {
                            type: 'category', 
                            axisTick: {
                              show: false 
                            },
                            axisLine: { 
                                show: false, 
                                lineStyle: { 
                                    color: '#cdd3ee'
                                }
                            },
                            splitLine: {
                                show: false
                            },
                            axisLabel: {
                                show: false, 
                                fontSize: 2, 
                                color: '#cdd3ee', 
                                formatter: '{value}'
                            },
                            data: [this.$t('TrustAdvisor.influence')] 
                        }
                    ],
                    // 系列列表
                    series: [
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [10, 0, 0, 10]
                            },
                            data: [this.highNumberCostOptimizingStatistics]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            data: [this.mediumNumberCostOptimizingStatistics]
                        },
                        {
                            type: 'bar', 
                            stack: this.$t('TrustAdvisor.total'),
                            barMaxWidth: 10, 
                            itemStyle: {
                                barBorderRadius: [0, 10, 10, 0] 
                            },
                            data: [this.lowNumberCostOptimizingStatistics]
                        }
                    ]
                })
            },
            /******************查询********************************/
            // 根据用户名查询Account列表
            getAccount: function () {
                this.$api.account.queryAWSAccounts("userName", getCookie(global.cookieName))
                .then(res => {
                    this.accountList = res.data;
                    // 默认选中第一个
                    if(this.accountList.length>0){
                        this.account=this.accountList[0].id;
                        this.checkAWSTrustedAdvisorOverview();
                    }
                    for (var i = 0; i < this.accountList.length; i++) {
                        this.accountList[i].name = this.accountList[i].name + '(' + this.accountList[i].accountTypeName + ')';
                    }
                })
            },
            // 切换账号
            changeAccount:function(){
                // 加载中
                this.spinShow=true;
                this.checkAWSTrustedAdvisorOverview();
            },
            // 查询TrustedAdvisor的总览信息
            checkAWSTrustedAdvisorOverview:function(){
                this.$api.trustedAdvisor.checkAWSTrustedAdvisorOverview({
                    "accountId":this.account
                })
                .then(res => {
                    // 高可用
                    if(res.data.faultToleranceStatistics){
                        this.spinShow=false;
                        this.suggestNumberFaultToleranceStatistics=res.data.faultToleranceStatistics.suggestNumber;
                        this.highNumberFaultToleranceStatistics=res.data.faultToleranceStatistics.highNumber;
                        this.mediumNumberFaultToleranceStatistics=res.data.faultToleranceStatistics.mediumNumber;
                        this.lowNumberFaultToleranceStatistics=res.data.faultToleranceStatistics.lowNumber;
                        this.affectedResourcesNumberFaultToleranceStatistics=res.data.faultToleranceStatistics.affectedResourcesNumber;
                    }
                    // 安全性
                    if(res.data.securityStatistics){
                        this.spinShow=false;
                        this.suggestNumberSecurityStatistics=res.data.securityStatistics.suggestNumber;
                        this.highNumberSecurityStatistics=res.data.securityStatistics.highNumber;
                        this.mediumNumberSecurityStatistics=res.data.securityStatistics.mediumNumber;
                        this.lowNumberSecurityStatistics=res.data.securityStatistics.lowNumber;
                        this.affectedResourcesNumberSecurityStatistics=res.data.securityStatistics.affectedResourcesNumber;
                    }
                    // 性能
                    if(res.data.performanceStatistics){
                        this.spinShow=false;
                        this.suggestNumberPerformanceStatistics=res.data.performanceStatistics.suggestNumber;
                        this.highNumberPerformanceStatistics=res.data.performanceStatistics.highNumber;
                        this.mediumNumberPerformanceStatistics=res.data.performanceStatistics.mediumNumber;
                        this.lowNumberPerformanceStatistics=res.data.performanceStatistics.lowNumber;
                        this.affectedResourcesNumberPerformanceStatistics=res.data.performanceStatistics.affectedResourcesNumber;
                    }
                    // 成本
                    if(res.data.costOptimizingStatistics){
                        this.spinShow=false;
                        this.suggestNumberCostOptimizingStatistics=res.data.costOptimizingStatistics.suggestNumber;
                        this.highNumberCostOptimizingStatistics=res.data.costOptimizingStatistics.highNumber;
                        this.mediumNumberCostOptimizingStatistics=res.data.costOptimizingStatistics.mediumNumber;
                        this.lowNumberCostOptimizingStatistics=res.data.costOptimizingStatistics.lowNumber;
                        this.affectedResourcesNumberCostOptimizingStatistics=res.data.costOptimizingStatistics.affectedResourcesNumber;
                    }
                    this.init();
                })
            }
        }
    }
</script>

<style scoped>
    .title
    {
        font-size:13px;
        font-weight: 600;
        padding: 10px;
        float:left;
        color:#000;
        margin-bottom: 40px;
    }
    .main span
    {
        font-size: 18px;
        cursor: pointer;
    }
    .demo-spin-container{
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/trustAdvisor/trustAdvisor_list/TrustAdvisorList.vue